import { render, staticRenderFns } from "./ClienteCredito.vue?vue&type=template&id=8cf0f372&scoped=true"
import script from "./ClienteCredito.vue?vue&type=script&lang=js"
export * from "./ClienteCredito.vue?vue&type=script&lang=js"
import style0 from "./ClienteCredito.vue?vue&type=style&index=0&id=8cf0f372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf0f372",
  null
  
)

export default component.exports